import McPager from './McPager.vue'

McPager.install = function(Vue){
    Vue.component(McPager.name, McPager);
}

export default McPager;